import { useEffect, useRef, useState } from 'react';
import useIframeSize from '../../../hooks/UseIframeSize';

interface IframeComponentProps {
  iframeSrc: string;
}

function IframeComponent({ iframeSrc }: IframeComponentProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState('auto');

  const { rect } = useIframeSize(iframeRef.current);

  useEffect(() => {
    if (!iframeRef.current) return;
    if (iframeHeight !== 'auto') setIframeHeight('auto');
  }, [iframeHeight, iframeSrc]);

  useEffect(() => {
    setIframeHeight(iframeHeight);
  }, [iframeHeight]);

  useEffect(() => {
    if (rect) setIframeHeight(`${rect.height}px`);
  }, [rect]);

  return (
    <>
      <iframe
        title="お問合せ"
        src={iframeSrc}
        width="100%"
        height={iframeHeight}
        ref={iframeRef}
      />
    </>
  );
}

export default IframeComponent;
